import {Routes, RouterModule} from '@angular/router';
import {LandingPageComponent} from './landing-page.component';
import {NgModule} from '@angular/core';


export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: LandingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class LandingPageRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/landing-page/landing-page-routing.module.ts